module.exports = __webpack_public_path__ + "static/media/30Seconds.8c73db70.png";